<template>
    <div class="brand">
        <h1 class="m-0">
            <router-link to="/">
                <img
                    :src="require('@/assets/images/logo-mini.png')"
                    alt="Supreme"
                    width="32"
                    height="32" />
            </router-link>
        </h1>
    </div>
</template>

<script>
export default {
  name: 'CLogo'
}
</script>
